<template>
  <div class="mypage-ticket-list-page">
    <sub-header-section
      class="mypage-ticket-list-page__header"
      :pageTitle="$tc('MypagePage.MypageTicketListPage.title')"
      backLink="/mypage"
    />
    <div class="mypage-ticket-list-page__body">
      <mypage-ticket-list-pane />
    </div>
    <global-navigation-pane current="mypage" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'
import SubHeaderSection from '@/components/common/Header/SubHeaderSection.vue'
import GlobalNavigationPane from '@/components/common/GlobalNavigation/GlobalNavigationPane.vue'
import MypageTicketListPane from '@/components/MypageTicketListPage/MypageTicketListPane.vue'

export default defineComponent({
  name: 'MypageTicketListPage',
  components: {
    MypageTicketListPane,
    GlobalNavigationPane,
    SubHeaderSection,
  },
})
</script>

<style scoped lang="scss">
.mypage-ticket-list-page {
  &__header {
    z-index: 3;
  }
}
</style>
